import { render, staticRenderFns } from "./GachaAnimation.vue?vue&type=template&id=1b98d77d&scoped=true&"
import script from "./GachaAnimation.vue?vue&type=script&lang=js&"
export * from "./GachaAnimation.vue?vue&type=script&lang=js&"
import style0 from "./GachaAnimation.vue?vue&type=style&index=0&id=1b98d77d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98d77d",
  null
  
)

export default component.exports